import { createContext } from 'react';
export var RuntimeReactContext = /*#__PURE__*/createContext({}); // eslint-disable-next-line @typescript-eslint/no-empty-interface